// TypeScript mirror of the Phase-0 public_booking schemas
// (backend/app/schemas/public_booking.py). Keep in sync with that file.

export type BookingSource = 'own_site' | 'line' | 'google' | 'cherie'

export interface BusinessProfile {
  slug: string
  name: string
  tagline: string | null
  logo_url: string | null
  accent_color: string | null
  address: string | null
  hours: Record<string, unknown> | null
  locale: string
  accepts_daycare: boolean
  accepts_grooming: boolean
  require_phone_otp: boolean
  auto_confirm: boolean
  deposit_required: boolean
  deposit_percent: number
  cancellation_hours: number
  lead_time_hours: number
  max_future_days: number
  // Phase 6A.5 identity pack — optional; SPA renders gracefully when missing.
  cover_photos?: string[]
  intro_video_url?: string | null
  intro_video_provider?: 'youtube' | 'vimeo' | null
}

export interface RoomCard {
  id: string
  name: string
  room_type: string
  capacity: number
  photo_url: string | null
  amenities: Record<string, unknown>
  daily_rate: string | number | null
  rate_tiers: Record<string, unknown> | null
  accepts_daycare: boolean
}

export interface PricingPreview {
  // Backend returns a flexible dict; surface the common fields loosely.
  total_amount?: string | number
  nights?: number
  deposit_amount?: string | number
  [k: string]: unknown
}

export interface IdentityStartResponse {
  identity_ticket: string
  delivery: string
  expires_in: number
  dev_code: string | null
}

export interface IdentityVerifyResponse {
  booking_token: string
  expires_in: number
}

export interface BookingResult {
  id: string
  kind: 'boarding' | 'grooming'
  status: string
  booking_source: string
  guest_id: string | null
  requires_confirmation: boolean
  created_at: string | null
}

export interface MultiBookingResult {
  order_id: string
  legs: BookingResult[]
  requires_confirmation: boolean
  deposit_required: boolean
  deposit_amount?: string | number | null
}

export interface GroomingSlot {
  groomer_id: string
  groomer_name: string | null
  start_time: string // ISO datetime (clinic-local time labelled UTC)
  end_time: string
}

export interface Groomer {
  id: string
  name: string
  name_zh: string | null
  photo_url: string | null
  specialties: string[]
  services_offered: string[]
}

export interface GroomingService {
  id: string
  name: string
  name_zh: string | null
  category: string
  species_tags: string[]
  base_price: string | number
  base_duration_minutes: number
}

export interface GroomingPackage {
  id: string
  name: string
  name_zh: string | null
  package_price: string | number
  base_duration_minutes: number
}

export interface GroomingCatalog {
  services: GroomingService[]
  packages: GroomingPackage[]
}

export class ApiError extends Error {
  status: number
  constructor(status: number, message: string) {
    super(message)
    this.status = status
    this.name = 'ApiError'
  }
}
